import X2JS from 'x2js';
import { show_modal, hide_modal } from './modals';
import * as jcore_cb from './core_callbacks';
import {
  do_magic,
  get_debug_variables,
  set_debug_variables,
} from './JCore/logging_jcore';
import { XmlRoot } from '@phi/logging/core-function-descriptions';

export function showxml() {
    var xmlroot = new XmlRoot(cfcd);
    var x2js = new X2JS();
    var xml_str = x2js.js2xml(xmlroot);

    xml_str = xml_str.replace(/<function_call_description>/g, "\n<function_call_description>");
    xml_str = xml_str.replace(/<\/function_call_description>/g, "\n</function_call_description>");
    xml_str = xml_str.replace(/<function_name>/g, "\n  <function_name>");
    //xml_str = xml_str.replace(/<\/function_name>/g,"\n  </function_name>");
    xml_str = xml_str.replace(/<parameter>/g, "\n    <parameter>");
    //xml_str = xml_str.replace(/<\/parameter>/g,"\n    </parameter>");

    xml_str = xml_str.replace(/&gt;/g, ">");
    xml_str = xml_str.replace(/&lt;/g, "<");
    xml_str = xml_str.replace(/&quot;/g, '"');

    xml_str = xml_str + "\n\n ===== LOG ===== \n\n";

    console.everything.forEach(function(l){
        if (l.type == "log" || l.type == "error") {
            xml_str += "\n" + l.datetime + "\n";
            if (l.type == "log")
            xml_str += "LOG:\n";
            else if (l.type == "error")
            xml_str += "ERROR:\n";
            if (Array.isArray(l.value)) {
            l.value.forEach(function(v){
                xml_str += v + "\n";
            });
            }
            else
            xml_str += l.value + "\n\n";
        }
    });

    // Start file download.
    downloadtofile("phi_debug.txt", xml_str);
}

export function downloadtofile(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function show_concise_xml() {
    var xmlroot = new XmlRoot(cfcd);
    var x2js = new X2JS();
    var xml_str = x2js.js2xml(xmlroot);

    var concise_xml_str = "";
    xmlroot.cfdf.function_call_description.forEach(function (fc) {
        concise_xml_str += fc.function_name + "(";

        if (fc.parameter.length == 0)
            concise_xml_str += ")\n";

        if (fc.parameter.length >= 1) {
            var p = (typeof fc.parameter[0] !== 'undefined') ? fc.parameter[0].toString() : "";
            concise_xml_str += p.length < 10 ? p : p.substring(0, 10) + "...";
            if (fc.parameter.length == 1)
                concise_xml_str += ")\n";
            else
                concise_xml_str += ", ";
        }

        if (fc.parameter.length >= 2) {
            var p = (typeof fc.parameter[1] !== 'undefined') ? fc.parameter[1].toString() : "";
            concise_xml_str += p.length < 10 ? p : p.substring(0, 10) + "...";
            if (fc.parameter.length == 2)
                concise_xml_str += ")\n";
            else
                concise_xml_str += ", ";
        }

        if (fc.parameter.length >= 3) {
            var p = (typeof fc.parameter[2] !== 'undefined') ? fc.parameter[2].toString() : "";
            concise_xml_str += p.length < 10 ? p : p.substring(0, 10) + "...";
            if (fc.parameter.length == 3)
                concise_xml_str += ")\n";
            else
                concise_xml_str += ", ...)\n";
        }
    });
    console_log("Function calls:");
    console_log(concise_xml_str);
}

export function startdomagic(force=false) {
    if (force)
        domagic();
    else {
        var str = "";

        str += "<p>Selected vertices:</p><p>";
        uid_selected_vertices.keys().forEach(function (k) {
            str = str + k + " ";
        });
        str += "</p>";
        str += "<p>Selected edges:</p><p>";

        uid_selected_edges.keys().forEach(function (k) {
            str = str + k + " ";
        });
        str += "</p>";
        str += "<p>Selected faces:</p><p>";
        uid_selected_faces.keys().forEach(function (k) {
            str = str + k + " ";
        });
        str += "</p>";
        str += "<p>Numbers:</p><p>";

        str += "<p><input class='modal-input' id='domagicnumbers' value = '" + magic_numbers_str + "'></input></p>";
        $("#domagichtml")[0].innerHTML = str;
        show_modal("doMagicModal");
    }
}

export function domagic() {
    var vertices = [];
    var edges = [];
    var faces = [];
    var numbers = [];

    // Split string
    magic_numbers_str = "";
    if (document.getElementById("domagicnumbers")) {
        magic_numbers_str = document.getElementById("domagicnumbers").value;
    }
    console_log(magic_numbers_str);

    if (magic_numbers_str == "")
        numbers = [];
    else
        numbers = magic_numbers_str.split(/[\s,]+/).map(Number);
    console_log(numbers);

    uid_selected_vertices.keys().forEach(function (k) {
        vertices.push(k);
    });

    uid_selected_edges.keys().forEach(function (k) {
        edges.push(k);
    });

    uid_selected_faces.keys().forEach(function (k) {
        faces.push(k);
    });

    // XXX uid_deselect_all_objects();
    do_magic(vertices, edges, faces, numbers);
    hide_modal("doMagicModal");
}

export function debugvarsmodal() {
    var str = "";

    str += "<p>Selected vertices:</p><p>";
    uid_selected_vertices.keys().forEach(function (k) {
        str = str + k + " ";
    });
    str += "</p>";
    str += "<p>Selected edges:</p><p>";

    uid_selected_edges.keys().forEach(function (k) {
        str = str + k + " ";
    });
    str += "</p>";
    str += "<p>Selected faces:</p><p>";
    uid_selected_faces.keys().forEach(function (k) {
        str = str + k + " ";
    });
    str += "</p>";
    str += "<br><br>";

    // Call core to get XML with debug vars
    var debug_vars_xml = get_debug_variables();
    console_log(debug_vars_xml);

    // Retrieve XML into JSON and then into a dictionary object
    var x2js = new X2JS();
    var json_obj = x2js.xml2js(debug_vars_xml);
    var json_str = JSON.stringify(json_obj);
    if (json_str == "") return;

    var version = json_obj.VarDescriptions.version;
    var nvars = json_obj.VarDescriptions.nvars;
    if (Number(nvars) > 0)
        if (Number(nvars > 1))
            json_obj.VarDescriptions.VarDesc.forEach(function (vd) {
                str += prepare_html_for_debug_vardesc(vd);
            });
        else
            str += prepare_html_for_debug_vardesc(json_obj.VarDescriptions.VarDesc);

    $("#debugvarshtml")[0].innerHTML = str;

    show_modal("DebugVarsModal");
}

export function prepare_html_for_debug_vardesc(vd) {
    var str;
    if (vd.type == "DUMMY") {
      str = '<h4 id="debug-vars-modal-title" class="modal-title">' + vd.name + ': </h4>'
      return str;
    }
    else {
      str = "<p>" + vd.name + "&nbsp&nbsp(" + vd.type + ")&nbsp&nbsp";
    }
    if ( vd.type == "STRING" ||
        vd.type == "INT" ||
        vd.type == "DOUBLE" ||
        vd.type == "VECTOR" ) {
        str += "<input class='modal-input' id='" + vd.name + "_var' value = '" + vd.val + "'></input>";
    }
    else if (vd.type == "BOOL") {
        str += "<input id='" + vd.name + "_var'" + "type='checkbox' ";
        if (vd.val == "1") str += "checked";
        str += "></input>";
    }
    else if (vd.type == "ENUM") {
        str += "<select class='form-select no-slot' id ='" + vd.name + "_var'>";
        if (Array.isArray(vd.EnumVals.ev)) {
          vd.EnumVals.ev.forEach(function (ev) {
              str += "<option value='" + ev + "' ";
              if (vd.val == ev) str += "selected='selected'";
              str += ">" + ev + "</option>";
          });
        }
        else {
          str += "<option value='" + vd.EnumVals.ev + "' ";
          str += "selected='selected'";
          str += ">" + vd.EnumVals.ev + "</option>";
        }
      str += "</select>";
    }
    if (vd.minval) str += "&nbsp&nbsp [ &nbsp " + vd.minval + " &nbsp < &nbsp ";
    if (vd.minval || vd.maxval) str += "value";
    if (vd.maxval) {
        str += " &nbsp < &nbsp " + vd.maxval + " &nbsp ]";
    }
    else if (vd.minval) {
        str += " &nbsp ]";
    }

    str += "</p>";
    return (str);
}

export function saveDebugVars() {
    var str = "";
    // Call core to get XML with debug vars. We need it to know how to create the XML.
    var debug_vars_xml = get_debug_variables();

    // Retrieve XML into JSON and then into a dictionary object
    var x2js = new X2JS();
    var json_obj = x2js.xml2js(debug_vars_xml);
    var json_str = JSON.stringify(json_obj);
    if (json_str == "") return;

    var version = json_obj.VarDescriptions.version;
    var nvars = json_obj.VarDescriptions.nvars;

    if (json_obj.VarDescriptions.nvars > 1)
        json_obj.VarDescriptions.VarDesc.forEach(function (vd) {
            save_debug_var_vardesc(vd);
        });
    else if (json_obj.VarDescriptions.nvars == 1)
        save_debug_var_vardesc(json_obj.VarDescriptions.VarDesc);

    var xmlAsStr = x2js.js2xml(json_obj);
    console_log(xmlAsStr);

    // Call core to pass XML with debug vars.
    var res = set_debug_variables(xmlAsStr);

    hide_modal("DebugVarsModal");
}

export function save_debug_var_vardesc(vd) {
  if (vd.type == "DUMMY")
    return;

  // Form id of DOM element that holds this value
  var varid = vd.name + "_var";
  var varval;
  // Retrieve value
  if (vd.type == "BOOL")
      if (document.getElementById(varid).checked) varval = "1";
      else varval = "0";
  else varval = document.getElementById(varid).value;
  vd.val = varval;
}

// From jcore.js for local version only:
window.phi_get_debug_variables = undefined
window.phi_do_magic = undefined
let phi_set_debug_variables;

export function debug_additional_initializations(Module) {
  let fptr;
  fptr = Module.addFunction(jcore_cb.display_show_vector, 'vfffffffiiii');
  Module.ccall("phi_install_display_show_vector", "number", ["number"], [fptr]);

  fptr = Module.addFunction(jcore_cb.display_show_point, 'vfffiii');
  Module.ccall("phi_install_display_show_point", "number", ["number"], [fptr]);

  fptr = Module.addFunction(jcore_cb.display_show_points_polyline, 'viiiii');
  Module.ccall("phi_install_display_show_points_polyline", "number", ["number"], [fptr]);

  phi_do_magic = Module.cwrap(
      "phi_do_magic",
      "number",
      [
          "number",
          "number", // Size of array of and pointer to array of vertex Ids.
          "number",
          "number", // Size of array of and pointer to array of edge Ids.
          "number",
          "number", // Size of array of and pointer to array of face Ids.
          "number",
          "number"
      ] // Size of array of and pointer to array of numbers.
  );

  phi_get_debug_variables = Module.cwrap(
      "phi_get_debug_variables",
      "number",
      [] // No parameters.
  );

  phi_set_debug_variables = Module.cwrap(
      "phi_set_debug_variables",
      "number",
      ["number", "number"] // An XML string with the variable descriptions.
  );
}

export function logged_jcore_do_magic(vertices, edges, faces, numbers) {
    console_log(vertices);
    console_log(edges);
    console_log(faces);
    console_log(numbers);

    // Vertices

    // Copy the object IDs data into an Int32Array
    var intDataV = new Int32Array(vertices.length);
    for (var i = 0; i < intDataV.length; i++) intDataV[i] = vertices[i];

    // get the length of the data in bytes
    var numBytesV = intDataV.length * intDataV.BYTES_PER_ELEMENT;

    // malloc enough space for the data
    var ptrV = Module._malloc(numBytesV);

    // get a bytes-wise view on the newly allocated buffer
    var heapBytesV = new Uint8Array(Module.HEAPU8.buffer, ptrV, numBytesV);

    // copy data into heapBytes
    heapBytesV.set(new Uint8Array(intDataV.buffer));

    // Edges

    // Copy the object IDs data into an Int32Array
    var intDataE = new Int32Array(edges.length);
    for (var i = 0; i < intDataE.length; i++) intDataE[i] = edges[i];

    // get the length of the data in bytes
    var numBytesE = intDataE.length * intDataE.BYTES_PER_ELEMENT;

    // malloc enough space for the data
    var ptrE = Module._malloc(numBytesE);

    // get a bytes-wise view on the newly allocated buffer
    var heapBytesE = new Uint8Array(Module.HEAPU8.buffer, ptrE, numBytesE);

    // copy data into heapBytes
    heapBytesE.set(new Uint8Array(intDataE.buffer));

    // Faces

    // Copy the object IDs data into an Int32Array
    var intDataF = new Int32Array(faces.length);
    for (var i = 0; i < intDataF.length; i++) intDataF[i] = faces[i];

    // get the length of the data in bytes
    var numBytesF = intDataF.length * intDataF.BYTES_PER_ELEMENT;

    // malloc enough space for the data
    var ptrF = Module._malloc(numBytesF);

    // get a bytes-wise view on the newly allocated buffer
    var heapBytesF = new Uint8Array(Module.HEAPU8.buffer, ptrF, numBytesF);

    // copy data into heapBytes
    heapBytesF.set(new Uint8Array(intDataF.buffer));

    // Numbers

    // Copy the object IDs data into an Float32Array
    var floatDataN = new Float32Array(numbers.length);
    for (var i = 0; i < floatDataN.length; i++) floatDataN[i] = numbers[i];

    // get the length of the data in bytes
    var numBytesN = floatDataN.length * floatDataN.BYTES_PER_ELEMENT;

    // malloc enough space for the data
    var ptrN = Module._malloc(numBytesN);

    // get a bytes-wise view on the newly allocated buffer
    var heapBytesN = new Uint8Array(Module.HEAPU8.buffer, ptrN, numBytesN);

    // copy data into heapBytes
    heapBytesN.set(new Uint8Array(floatDataN.buffer));

    // call the c function
    var res = phi_do_magic(
        intDataV.length,
        heapBytesV.byteOffset,
        intDataE.length,
        heapBytesE.byteOffset,
        intDataF.length,
        heapBytesF.byteOffset,
        floatDataN.length,
        heapBytesN.byteOffset
    );

    uil_handle_post_core_action();
    console_log(res);
    return res;
}

export function logged_jcore_get_debug_variables() {
    var s = phi_get_debug_variables();
    var str = Module.UTF8ToString(s);
    return str;
}

export function logged_jcore_set_debug_variables(str) {
    var strptr = Module._malloc(str.length + 1);
    Module.stringToUTF8(str, strptr, str.length + 1);
    var res = phi_set_debug_variables(strptr, str.length);
    return res;
}
